// 数据与交互类型

export enum InputType {
  video = 'video',
  podcast = 'podcast',
  moments = 'moments',
  post = 'post',
  article = 'article',
}

export enum InputMode {
  voice = 'voice',
  keyboard = 'keyboard',
}

// 模板项
export type TemplateItem = {
  id: number;
  coverUrl: string;
  name: string;
};

// 分组数据类型
export type GroupedVideos = Record<string, Array<{ id: string; videoThumbnail: string; content: string }>>;
export type GroupedPodcasts = Record<string, Array<{ id: string; coverUrl: string; content: string; audioUrl: string }>>;
export type GroupedMoments = Record<string, Array<{ id: string; images: string[]; content: string }>>;
export type GroupedPosts = Record<string, Array<{ id: string; images: string[]; content: string }>>;
export type GroupedArticles = Record<string, Array<{
  id: string;
  image: string;
  title: string;
  quote: string;
  contentHtml: string;
  publishedAt?: string;
}>>;

// 回调
export type RefreshCallback = () => Promise<void>;
export type LoadCallback = () => Promise<void>;
export type ChooseCallback = (id: string) => Promise<void>;


